import React from 'react'
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import './style.css';
import { Button, Form, Input, InputNumber, Upload } from 'antd';
import TextArea from 'antd/es/input/TextArea';

const uploadImageContainerStyle = {
    flex: '0 0 120px',
    height: '120px',
    width: '120px',
    borderRadius: '50%',
    overflow: 'hidden',
    border: '1px dashed #444',
    backgroundColor: '#d8d8d8',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    cursor: 'pointer'
};

const uploadTextStyle = {
    fontSize: '14px',
    color: '#444',
    marginTop: '0px'
};

const contentStyle = {
    flex: '1',
    width: '100%'
};

const titleStyle = {
    fontSize: '18px',
    fontWeight: '700',
    color: '#333',
    margin: '16px 0 0 0',
};

const detailsBoxStyle = {
    height: '130px',
    width: '100%',
    padding: '8px',
    border: '2px solid #fd0088',
    backgroundColor: '#f3e0ee',
    borderRadius: '16px',
    fontSize: '14px',
    color: '#666',
    overflow: 'auto',
};

const deleteIconStyle = {
    position: 'absolute',
    top: '-15px',
    right: '-15px',
    padding: 10,
    backgroundColor: '#fd0088',
    color: '#fff',
    fontSize: '20px',
    cursor: 'pointer',
    marginLeft: '16px',
    textAlign: 'center', // Fixed the incorrect capitalization
    display: 'flex', // Center the icon properly
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px' // Adds a rounded look
};

const inputStyle = {
    // height: '40px',
    width: '100%',
    padding: '8px',
    border: '2px solid #fd0088',
    backgroundColor: '#f3e0ee',
    borderRadius: '12px',
    fontSize: '14px',
    color: '#666',
    overflow: 'auto',
};

const buttonFile = {
    backgroundColor: '#fd0088',
    color: 'white',
    width: "100%",
    fontWeight: 'bold',
    fontSize: "clamp(14px,2.5vw,18px)",
    height: '40px',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'background 0.3s ease',
};



export default function QuotationCustomCard({ onRemove, data, onChangeData, index }) {

    const handleBeforeUpload = async (file) => {


        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => {
            onChangeData('product_logo', { uid: file.uid, url: reader.result, name: file.name }, index)
        };

        return false;
    };


    const handleBeforeUploadImage = async (file) => {


        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => {
            onChangeData('product_image', { uid: file.uid, url: reader.result, name: file.name }, index)
        };

        return false;
    };


    return (
        <div className="quotation-custom-card" style={{ position: 'relative', width: "100%" }} >

            {console.log('data.product_image :>> ', data.product_image)}

            <Form.Item initialValue={data.product_image ? [data.product_image] : []} rules={[{ required: true, message: "กรุณา 'แนบไฟล์ภาพสินค้า'" }]} name={`product_image_${index}`}>
                <Upload listType="picture-circle" style={{ width: "100%" }} fileList={data.product_image ? [data.product_image] : []} beforeUpload={handleBeforeUploadImage} onRemove={() => onChangeData('product_image', null, index)} name="product_image" >
                    {!data.product_image && <div style={uploadImageContainerStyle}>
                        <h1 style={{ fontSize: '32px', margin: 0, marginBottom: -15 }}>+</h1>
                        <div style={uploadTextStyle}>แนบไฟล์ภาพสินค้า</div>
                    </div>}
                </Upload>
            </Form.Item>




            <div style={contentStyle}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={titleStyle}>ประเภทสินค้า <span style={{ color: '#fd0088' }}>*</span></h3>
                    <DeleteOutlined style={deleteIconStyle} onClick={() => onRemove(data.id)} />
                </div>

                {console.log('data :>> ', data.name)}

                <Form.Item initialValue={data.name} rules={[{ required: true, message: "กรุณากรอก 'จำนวนที่ต้องการผลิต'" }]} name={`name_${index}`}>
                    <Input value={data.name} type="text" onChange={(e) => onChangeData("name", e.target.value, index)} style={inputStyle} />
                </Form.Item>



                <h3>จำนวนที่ต้องการผลิต <span style={{ color: "#fd0088" }}>*</span></h3>

                <Form.Item initialValue={data.product_qty} rules={[{ required: true, message: "กรุณากรอก 'จำนวนที่ต้องการผลิต'" }]} name={`product_qty${index}`}>
                    <InputNumber min={0} value={data.product_qty} onChange={(e) => onChangeData("product_qty", e, index)} type="text" style={inputStyle} />
                </Form.Item>


                <h3>แบบโลโก้ (จำนวนกี่สี)</h3>
                <div style={{ display: 'flex', gap: '10px' }} >
                    <TextArea value={data.product_logo_count} onChange={(e) => onChangeData("product_logo_count", e.target.value, index)} type="text" style={inputStyle} />
                </div>
                <div style={{ marginTop: 15, width: "100%" }} >
                    <Upload style={{ width: "100% !important" }} fileList={data.product_logo ? [data.product_logo] : []} beforeUpload={handleBeforeUpload} onRemove={() => onChangeData('product_logo', null, index)} name="product_logo" >
                        {!data.product_logo && <Button style={{ ...buttonFile, width: "100%" }}><UploadOutlined style={{ fontSize: 20 }} /> แนบไฟล์โลโก้</Button>}
                    </Upload>
                </div>
                <h3>รายละเอียดเพิ่มเติม</h3>
                <TextArea value={data.product_detail} onChange={(e) => onChangeData("product_detail", e.target.value, index)} type="text" style={detailsBoxStyle} />
            </div>
        </div>
    );
}